<script>
    /// require component
    import { codemirror } from 'vue-codemirror'

    // require styles
    import 'codemirror/lib/codemirror.css'
    // language js
    import 'codemirror/mode/javascript/javascript.js'
    import 'codemirror/mode/xml/xml.js'
    import 'codemirror/mode/htmlmixed/htmlmixed.js'
    // theme css
    import 'codemirror/theme/neat.css'
    // require active-line.js
    import'codemirror/addon/selection/active-line.js'
    // styleSelectedText
    import'codemirror/addon/selection/mark-selection.js'
    import'codemirror/addon/search/searchcursor.js'
    // hint
    import'codemirror/addon/hint/show-hint.js'
    import'codemirror/addon/hint/show-hint.css'
    import'codemirror/addon/hint/javascript-hint.js'
    import'codemirror/addon/selection/active-line.js'
    // highlightSelectionMatches
    import'codemirror/addon/scroll/annotatescrollbar.js'
    import'codemirror/addon/search/matchesonscrollbar.js'
    import'codemirror/addon/search/searchcursor.js'
    import'codemirror/addon/search/match-highlighter.js'
    // keyMap
    import'codemirror/mode/clike/clike.js'
    import'codemirror/addon/edit/matchbrackets.js'
    import'codemirror/addon/comment/comment.js'
    import'codemirror/addon/dialog/dialog.js'
    import'codemirror/addon/dialog/dialog.css'
    import'codemirror/addon/search/searchcursor.js'
    import'codemirror/addon/search/search.js'
    import'codemirror/keymap/sublime.js'
    // foldGutter
    import'codemirror/addon/fold/foldgutter.css'
    import'codemirror/addon/fold/brace-fold.js'
    import'codemirror/addon/fold/comment-fold.js'
    import'codemirror/addon/fold/foldcode.js'
    import'codemirror/addon/fold/foldgutter.js'
    import'codemirror/addon/fold/indent-fold.js'
    import'codemirror/addon/fold/markdown-fold.js'
    import'codemirror/addon/fold/xml-fold.js'


    import preview from './common/preview.vue';
    import dragdrop from './common/dragdrop.vue';
    import editor from './campaign/editor.vue';
    import settings from './campaign/campaignSettings.vue';
    import toaster from "../common/toaster";
    //
    export default {
        components: {
            dragdrop,
            editor,
            settings,
            preview,
            codemirror
        },
        props: [
            'widget',
            'inline',
            'back_url',
            'add',
            'insertX',
            'insertY',
            'insert_data',
            'parent_layer_limitation',
            'parent_usergroup_limitation',
            'publish_privilege',
            'approve_privilege'
        ],
        data: function () {
            return {
                t_endless_loop: Lang.langGet("Checking for endless loop. This may take a while."),
                t_endless_loop_fail: Lang.langGet("You are not allowed to add the element, an endless loop was detected:"),
                previewing: false,
                creator: false,
                dynamic: false,
                dragulaObject: null,
                campaign_state_origin: null,
                campaign_state: null,
                campaign_link_id: null,
                active_element: -1,
                next_active_element: null,
                preview_url: '',
                startDragdropCollapsed: false,
                startSettingsCollapsed: false,
                startDragdropActive: false,
                startSettingsActive: false,
                inner_name: '',

                parentLayerLimitation: [],
                parentUsergroupLimitation: [],
                currentLayerLimitation: [],
                currentUsergroupLimitation: [],
                updatePublish: 0,
                updateApprove: -1,
                t_auto_approve: Lang.langGet("The modified content gets approved in all layers."),
                t_auto_keep_approved: Lang.langGet("Approved state of layer elements is not changed."),
                t_auto_disapprove: Lang.langGet("Layer elements that contain the modified content get disapproved."),
                t_auto_publish: Lang.langGet("Layers that contain the modified content get published to the relevant screens."),
                t_auto_not_publish: Lang.langGet("Layer elements do not get published."),

                t_manifest: Lang.langGet("Manifest XML File"),
                t_index: Lang.langGet("Index HTML File"),
                t_edit_failed: Lang.langGet("Failed to edit widget"),
                saving: false,
                grid: '2cols',
                mode: 'tiles',

                inner_widget_definition: null,
                inner_widget_element: null,
                width: 100,
                height: 100,

                selected_code: 'manifest',
                code_manifest: '',
                code_index: '',
                cmOptions: {
                    tabSize: 4,
                    styleActiveLine: true,
                    autoCloseTags: true,
                    lineNumbers: true,
                    lineWrapping: true,
                    styleSelectedText: false,
                    line: true,
                    foldGutter: true,
                    gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
                    highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },
                    mode: 'text/html',
                    // hint.js options
                    hintOptions:{
                        completeSingle: false
                    },
                    matchBrackets: true,
                    showCursorWhenSelecting: true,
                    theme: "default",
                    extraKeys: { "Ctrl": "autocomplete", "Shift-Tab": "indentLess" },
                },
            }
        },
        computed: {

        },
        methods: {
            updateWidget: function (update) {
                this.saving = true;
                // this.inner_widget_definition.code_manifest = this.code_manifest;
                // this.inner_widget_definition.code_index = this.code_index;
                var editor = document.querySelector('#cm-manifest .CodeMirror').CodeMirror;
                this.inner_widget_definition.code_manifest = editor.getValue();
                editor = document.querySelector('#cm-index .CodeMirror').CodeMirror;
                this.inner_widget_definition.code_index = editor.getValue();

                axios.post('/administration/widget/edit/update', {
                    id: this.inner_widget_definition.id,
                    project: Laravel.activeProject,
                    widget: this.inner_widget_definition,
                    approve: update.approve ?? 0,
                    publish: update.publish ?? 0,
                }).then((response) => {
                    this.saving = false;
                }).catch((error) => {
                    this.saving = false;

                    if (error.response.status === 401) {
                        window.location = '/login';
                    } else if (error.response.status === 422) {
                        let errorString = this.t_edit_failed + ': ';

                        for (let key in error.response.data) {
                            errorString = errorString + error.response.data[key] + ' ';
                        }

                        let escapedString = $("<div>").text(errorString).html();
                        toaster.error(escapedString);
                    } else if (error.response.status === 400) {
                        let errorString = this.t_edit_failed + ': ';

                        for (let key in error.response.data.error) {
                            errorString = errorString + error.response.data.error[key] + ' ';
                        }

                        let escapedString = $("<div>").text(errorString).html();
                        toaster.error(escapedString);
                    } else {
                        toaster.error(this.t_edit_failed);
                    }
                });
            },
            updateWidgetWrapper: function (update) {
                if (update.publish && !localStorage.getItem("widget-autopublish-confirm-" + Laravel.activeProject)) {
                    EaseEventBus.fire('showAutopublishWarning', {data: update, type: 'widget', task: 'Save'});
                } else {
                    this.updateWidget(update);
                }
            },
            update: function (verified = false, approve=0, publish=0) {
                if (this.saving !== true) {
                    if (verified === false && this.must_convert === false && this.campaign_link_id !== null) {
                        EaseEventBus.fire('showSaveCampaignDialog');
                    } else {
                        if (this.inline === 'true') {
                            this.redirect_url = this.back_url;
                            this.updateWidgetWrapper({refresh: false, approve: approve, publish: publish});
                        } else {
                            this.updateWidgetWrapper({refresh: true, approve: approve, publish: publish});
                        }
                    }
                }
            },
        },
        mounted() {
            let json = JSON.parse(this.widget);

            var editor = document.querySelector('#cm-manifest .CodeMirror').CodeMirror;
            editor.setValue(json.code_manifest)
            editor.getDoc().clearHistory();
            editor = document.querySelector('#cm-index .CodeMirror').CodeMirror;
            editor.setValue(json.code_index)
            editor.getDoc().clearHistory();
            this.$nextTick(() => {
                var editor = document.querySelector('#cm-manifest .CodeMirror').CodeMirror;
                editor.setCursor({line: 0, ch: 0})
                editor = document.querySelector('#cm-index .CodeMirror').CodeMirror;
                editor.setCursor({line: 0, ch: 0})
            });

            this.inner_widget_definition = json;
            this.inner_widget_element = {};

            window.addEventListener('beforeunload', (e) => {
                let unsavedChanges = false;
                var editor = document.querySelector('#cm-manifest .CodeMirror').CodeMirror;
                if (!empty(editor.getDoc().getHistory())) {
                    unsavedChanges = true;
                }
                editor = document.querySelector('#cm-index .CodeMirror').CodeMirror;
                if (!empty(editor.getDoc().getHistory())) {
                    unsavedChanges = true;
                }
                if(unsavedChanges) {
                    e.returnValue = 'Are you sure you want to leave?';
                }
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.processWindowSize);
        }
    }
</script>

<style>
.CodeMirror-focused .cm-matchhighlight {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAAFklEQVQI12NgYGBgkKzc8x9CMDAwAAAmhwSbidEoSQAAAABJRU5ErkJggg==);
    background-position: bottom;
    background-repeat: repeat-x;
}
.cm-matchhighlight {background-color: lightgreen}
.CodeMirror-selection-highlight-scrollbar {background-color: green}
</style>
